import type { QueryClient } from "react-query";

import { useResourceDependentsPageQuery } from "src/graphql";

export const RESOURCE_DEPENDENTS_PAGE_SIZE = 100;

type LoadResourceDependentsPageArgs = {
  queryClient: QueryClient;
  resourceType: string;
  resourceId: string;
  snapshotToken: string;
  cursor?: string | null;
};

export function loadResourceDependentsPage({
  queryClient,
  resourceType,
  resourceId,
  snapshotToken,
  cursor,
}: LoadResourceDependentsPageArgs) {
  const variables = {
    resourceType,
    resourceId,
    snapshotToken,
    limit: RESOURCE_DEPENDENTS_PAGE_SIZE,
    cursor: cursor ?? null,
  };

  return queryClient.fetchQuery({
    queryKey: useResourceDependentsPageQuery.getKey(variables),
    queryFn: useResourceDependentsPageQuery.fetcher(variables),
    staleTime: Infinity,
  });
}
